import { useState } from "react";
import { GiftcardItem, SelectedGiftcard } from "src/store/slices/item/subitems/giftcards.types";

export default function useGiftcardValue(item: GiftcardItem | undefined) {
  const [values, setValues] = useState<Record<string, number>>({});

  const onRangeChange = (value: number) => {
    if (item) setValues((prev) => ({ ...prev, [item.code]: value }));
  };

  if (!item?.isRange) return { data: item as SelectedGiftcard | undefined, range: undefined, onRangeChange };

  const value = values[item.code] ?? item.min;

  return {
    data: { ...item, totalPrice: value, points: Math.round(value * item.pointsFactor) } as SelectedGiftcard,
    range: { min: item.min, max: item.max, value },
    onRangeChange,
  };
}
